import { mustBeEmail, mustBeFilled, mustBeLessThan, mustBeMoreThan } from '../../libs/validators';

export const inputEmailConfig = {
  autoComplete: 'email',
  description: 'Exemple : jean.dupont@orange.fr',
  label: 'Adresse électronique',
  name: 'email',
  validators: {
    format: [
      mustBeMoreThan(3),
      mustBeLessThan(256),
      mustBeEmail('Veuillez saisir une adresse électronique valide'),
    ],
    submit: mustBeFilled('Veuillez saisir une adresse email'),
  },
};
